import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=23adcb54&scoped=true"
import script from "./complain.vue?vue&type=script&lang=js"
export * from "./complain.vue?vue&type=script&lang=js"
import style0 from "./complain.vue?vue&type=style&index=0&id=23adcb54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23adcb54",
  null
  
)

export default component.exports